import React from 'react';
import { useSelector } from 'react-redux';
import { Menu } from 'lucide-react';
import { Button } from './ui/button';
import { cn } from '../lib/utils';

// Sub-components
import NavBreadcrumb from './navbar/NavBreadcrumb';
import NavSearch from './navbar/NavSearch';
import NavActions from './navbar/NavActions';
import NavCreditsHub from './navbar/NavCreditsHub';
import UserMenu from './navbar/UserMenu';

export default function Navbar({ onMenuToggle }) {
    const { isCollapsed } = useSelector((state) => state.ui);

    return (
        <header className={cn(
            "fixed top-0 right-0 left-0 h-16 bg-background/60 backdrop-blur-xl border-b border-border/50 z-30 flex items-center justify-between px-4 sm:px-8 transition-all duration-500 ease-in-out",
            isCollapsed ? "lg:left-[68px]" : "lg:left-[300px] xl:left-[320px]"
        )}>
            {/* Left side: Hamburger + Breadcrumb */}
            <div className="flex items-center gap-4">
                {/* Mobile hamburger */}
                <Button 
                    variant="ghost" 
                    size="icon" 
                    onClick={onMenuToggle} 
                    className="lg:hidden h-9 w-9 text-muted-foreground hover:text-foreground hover:bg-accent/40 rounded-xl"
                >
                    <Menu className="h-5 w-5" />
                    <span className="sr-only">Open menu</span>
                </Button>
                
                <div className="hidden lg:block">
                    <NavBreadcrumb />
                </div>
            </div>

            {/* Middle: Real Search/Command Trigger */}
            <div className="flex-1 flex justify-center max-w-2xl px-4">
                <NavSearch />
            </div>

            {/* Right side: Global Actions & Profile */}
            <div className="flex items-center gap-2 sm:gap-4">
                <NavCreditsHub />
                <NavActions />
                
                <div className="hidden sm:block h-6 w-px bg-border/50 mx-1" />
                
                <UserMenu />
            </div>
        </header>
    );
}
